import { Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import BlackListWarning from 'components/BlackListWarning';
import Card, { CardButtonWrap } from 'components/Card';
import { useBlackWhiteStatus } from 'hooks/useBlackWhiteStatus';
import { useStorageData } from 'hooks/useStorageData';
import store from '../../store';
import { descConfig, tipsConfig } from './config';
import style from './style.scss';

export default function Introduce() {
    const { data } = useBlackWhiteStatus('POSITION_TRANSFER_IN');
    const navigate = useNavigate();
    const { clearStorageData } = useStorageData();
    const handleClick = () => {
        /**
         * 每次进入转股流程都应该是新的流程, 清除原有缓存的页面信息和编辑状态
         * 具体case: 比如之前用户信息填到一半了, 然后手敲地址, 或者点击页面上的其他按钮去了别的流程
         */
        clearStorageData();
        store.clearBrokerMode();
        navigate('../step/broker');
    };

    if (data?.isBlack) {
        return <BlackListWarning source="withdraw" type="Transfer" />;
    }

    return (
        <Card form>
            <h3 className="transfer-title">{__('Transfer Positions')}</h3>
            <div className="transfer-desc">
                {descConfig.map((val, index) => (
                    <p className="desc-item" key={index}>
                        {val}
                    </p>
                ))}
            </div>
            <div className={style.tips}>
                {tipsConfig.map((val, index) => (
                    <div className={style.tipItem} key={index}>
                        <div className={style.index}>{index + 1}</div>
                        <div className={style.tipContent}>{val}</div>
                    </div>
                ))}
            </div>
            <CardButtonWrap>
                <Button size="large" type="primary" onClick={handleClick}>
                    {__('Continue')}
                </Button>
            </CardButtonWrap>
            <Link className={style.viewHistory} to="../history">
                {__('View Transfer History')}
            </Link>
        </Card>
    );
}
